var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-jumbotron',{attrs:{"header":"Forbidden","header-level":"5","lead":"Sorry, this data is not for your eyes :("}})
}
var staticRenderFns = []

export { render, staticRenderFns }